import React, { useMemo } from 'react';
import { Chip, Typography } from '@mui/material';
import { Image } from './styles';

type ActiveGranit = {
  id: string;
  granit?: {
    id: string;
    name: string;
    reducedImage: string;
  };
};

type TextureSelectionProps = {
  hasSelectedAllPieces: boolean;
  setHasSelectedAllPieces: (value: boolean) => void;
  activeGranits: ActiveGranit[];
  selectedDominant?: string;
  setSelectedDominant: (id: string | undefined) => void;
  buckets?: { BUCKET_3D_PIECES?: string };
  activePieces: any[];
  pieceIndex: number;
  setValue: <T extends any>(stateName: string, value: T) => void;
  selectPieceWithGranitId: (granitId: string) => void;
};

export const TextureSelection: React.FC<TextureSelectionProps> = ({
  hasSelectedAllPieces,
  setHasSelectedAllPieces,
  activeGranits,
  selectedDominant,
  setSelectedDominant,
  buckets,
  activePieces,
  pieceIndex,
  setValue,
  selectPieceWithGranitId,
}) => {

  const canSelectEveryPieces = useMemo(() => {
    const materials = activePieces.map((el) => el.material);
    
    const uniqueMaterials = [...new Set(materials)];
    return uniqueMaterials.length === 1;
  }, [activePieces]);
  return (
    <>
      <Typography
        variant="body2"
        color="#667085"
        style={{
          fontFamily: 'Open Sans',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '12px',
        }}
      >
        Sélectionner
      </Typography>
      {canSelectEveryPieces ? 
        <Chip
          color={hasSelectedAllPieces ? 'primary' : 'default'}
          label="Toutes les pièces"
          onClick={() => {
            if (hasSelectedAllPieces) {
              setHasSelectedAllPieces(false);
              setSelectedDominant(undefined);
              setValue('hasAdvancedMode', false);
            } else {
              setHasSelectedAllPieces(true);
              setSelectedDominant(undefined);
              setValue('hasAdvancedMode', true);
            }
          }}
        />
      : null}

      {activeGranits.map((el) => {
          return (
            <Chip
              key={el.id}
              avatar={
                <Image
                  src={`${buckets?.BUCKET_3D_PIECES || ''}/${el.granit?.reducedImage}`}
                  alt="texture"
                  borderRadius={50}
                />
              }
              color={selectedDominant === el.id ? 'primary' : 'default'}
              label={`Dominante ${el.granit?.name}`}
              onClick={() => {
                if (selectedDominant === el.id) {
                  setSelectedDominant(undefined);
                  setValue('hasAdvancedMode', false);
                } else {
                  setValue('hasAdvancedMode', true);
                  setSelectedDominant(el.id);
                  selectPieceWithGranitId(el.id);
                  setHasSelectedAllPieces(false);
                }
              }}
            />
          );
        })}
    </>
  );
};
